import type { EntryPoint, EntryPointComponent } from 'react-relay';
/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import LookAndFeelPageQuery, {
	type LookAndFeelPageQuery as LookAndFeelPageQueryType,
} from './__generated__/LookAndFeelPageQuery.graphql.ts';

type LookAndFeelEntryPointComponent = EntryPointComponent<
	{
		lookAndFeelQuery: LookAndFeelPageQueryType;
	},
	{},
	{},
	{}
>;

export const lookAndFeelEntryPoint: EntryPoint<
	LookAndFeelEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<LookAndFeelEntryPointComponent>(
		/* webpackChunkName: "async-look-and-feel-page" */ './LookAndFeelPage.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: ({ tenantContext }: EntryPointRouteParams) => {
		const { cloudId } = tenantContext;

		return {
			queries: {
				lookAndFeelQuery: {
					options: { fetchPolicy: 'store-and-network' as const },
					parameters: LookAndFeelPageQuery,
					variables: {
						cloudId,
					},
				},
			},
		};
	},
});
